/* eslint-disable no-param-reassign */
import { notification } from 'antd';
import { randomBytes } from 'crypto';
import debug from 'debug';

import {
	GET_PEOPLE_ITEMS_START,
	GET_PEOPLE_ITEMS_SUCCESS,
	GET_PEOPLE_ITEMS_FAIL,
	UPDATE_PEOPLE_ITEM_START,
	UPDATE_PEOPLE_ITEM_SUCCESS,
	UPDATE_PEOPLE_ITEM_FAIL,
	DELETE_PEOPLE_ITEM_START,
	DELETE_PEOPLE_ITEM_SUCCESS,
	DELETE_PEOPLE_ITEM_FAIL,
} from 'admin/constants';
import * as api from 'api';

const log = debug('app:actions:items');

export function getPeopleItems(categoryId) {
	return async dispatch => {
		try {
			dispatch({ type: GET_PEOPLE_ITEMS_START });

			const result = await api.getPeopleItems(categoryId);

			if (result.success) {
				dispatch({
					type: GET_PEOPLE_ITEMS_SUCCESS,
					payload: result.data,
				});
			} else {
				dispatch({ type: GET_PEOPLE_ITEMS_FAIL });
			}
		} catch (e) {
			dispatch({ type: GET_PEOPLE_ITEMS_FAIL });
		}
	};
}

export function updatePeopleItem(categoryId, data) {
	return async (dispatch, getState) => {
		try {
			let { id } = data;
			const isCreateMode = !id;

			dispatch({ type: UPDATE_PEOPLE_ITEM_START });

			if (isCreateMode) {
				id = randomBytes(16).toString('hex');
			}

			const payload = { ...data, id, categoryId };
			const result = await api.updateItem(payload);

			log('updateItem', payload);

			if (result.success) {
				notification.success({
					message: isCreateMode ? 'Created' : 'Updated',
					description: isCreateMode
						? `${data.songName} has been successfuly created`
						: `${data.songName} has been successfuly updated`,
				});
				dispatch({ type: UPDATE_PEOPLE_ITEM_SUCCESS, payload: { ...data, id, categoryId } });
			} else {
				log('updatePeopleItem FAIL', { message: 'Error!', description: result.message });
				notification.error({ message: 'Error!', description: result.message });
				dispatch({ type: UPDATE_PEOPLE_ITEM_FAIL });
			}
		} catch (e) {
			dispatch({ type: UPDATE_PEOPLE_ITEM_FAIL });
		}
	};
}

export function deletePeopleItem(data) {
	return async dispatch => {
		try {
			log('deleteJob data', data);
			dispatch({ type: DELETE_PEOPLE_ITEM_START });

			const result = await api.deleteItem({ ...data });
			log('deleteItem result', result);

			if (result.success) {
				notification.success({
					message: 'Deleted',
					description: `${data.songName} has been successfuly deleted`,
				});
				dispatch({ type: DELETE_PEOPLE_ITEM_SUCCESS, payload: { ...data } });
			} else {
				notification.error({ message: 'Error!', description: result.message });
				dispatch({ type: DELETE_PEOPLE_ITEM_FAIL });
			}
		} catch (e) {
			dispatch({ type: DELETE_PEOPLE_ITEM_FAIL });
		}
	};
}
